export const environment = {
  env: 'production',
  production: true,
  appApi: 'https://pregnantwithdiabetes.vercel.app/api/app',
  release: 'a7b7f0b452ea15a65e96668124653e2aa08168d3',
  dist: 'web',
  environment: 'production',
};
